import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import {
  GetCirclebyID,
  GetWardsbyCircleId,
  GetZone,
} from "../../Apis/organizationApi";
import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { TeritaryVehicleCountDashboardReport, TeritaryVehicleDashboardReport } from "../../Apis/TransferStationReport/teritaryDashboardReportApi";
import { getAllTransferStationMaster } from "../../Apis/transferStationApi";
import { AllVehicleTypeDetails } from "../../Apis/vehicleApi";
import { DashboardLoader } from "../../Common/ShimmerLoader";
import { toast } from "react-toastify";
import isGHMC from "../../Common/helper/helpar";

const TeritaryDashboardReport = () => {
  const libraries = ["places"];
  const isProd = isGHMC();
  // const transferStationDashboardResults = require("./transferStationZones.json");
  const pieChartRef = useRef(null);
  const pieChartInstance = useRef(null);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);
  const [selectedTransferStation, setSelectedTransferStation] = useState(null);
  const [allVehicleDashboardReport, setAllVehicleDashboardReport] = useState([]);
  const [selectedZone, setSelectedZone] = useState(null);
  const [allZones, setAllZones] = useState([]);
  const [allCircles, setAllCircles] = useState([]);
  const [allWards, setAllWards] = useState([]);
  const [transferStationMarkers, setTransferStationMarkers] = useState([]);
  const [transferStationMarkers1, setTransferStationMarkers1] = useState([]);
  const [selectedCircle, setSelectedCircle] = useState(null);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [selectedWard, setSelectedWard] = useState(null);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [allVehicleTypeNames, setAllVehicleTypeNames] = useState({});
  const [transactionCountData, setTransactionCountData] = useState([]);
  const [pieChartData, setPieChartData] = useState({});
  const [transferStationDashboardResults, setTransferStationDashboardResults] =
    useState([]);
  const [mapCenter, setMapCenter] = useState({
    lat: 28.6139,
    lng: 77.2090,
  });
  const resetRef = useRef(null);
  // const { isLoaded, loadError } = useLoadScript({
  //   googleMapsApiKey: "AIzaSyAm9ekbF8SnmFeUH4BvEffHYu_TuUieoDw", // Replace with your Google Maps API key
  //   libraries,
  // });

  useEffect(() => {
    const fetchTransferStations = async () => {
      try {
        const transferStationData = await getAllTransferStationMaster();
        // Assuming the data structure returned by the API matches your expectations
        // Set the transfer station results state
        setTransferStationDashboardResults(transferStationData);
      } catch (error) {
        console.error("Error fetching transfer station data:", error);
      }
    };

    // Call the function to fetch transfer station data
    fetchTransferStations();
  }, []);

  // Modify this function to return an object with vehicle type IDs as keys and their names as values
  const getVehicleTypeNames = async () => {
    try {
      const allVehicleTypes = await AllVehicleTypeDetails();
      const vehicleTypeNames = {};
      allVehicleTypes.forEach((vehicleType) => {
        vehicleTypeNames[vehicleType.vehicleTypeId] =
          vehicleType.vehicleTypeName;
      });
      return vehicleTypeNames;
    } catch (error) {
      console.error("Error fetching all vehicle types:", error);
      return {};
    }
  };

  const fetchVehicleTypeNames = async () => {
    const vehicleTypeNames = await getVehicleTypeNames();
    setAllVehicleTypeNames(vehicleTypeNames);
  };

  useEffect(() => {
    fetchVehicleTypeNames();
  }, []);


    const handleSearch = async () => {
      try {
        setIsOptionsLoading(true)
        // Call both APIs when start date or end date changes
        const [vehicleResponse, transactionResponse] = await Promise.all([
          TeritaryVehicleCountDashboardReport(
            startDate,
            endDate,
            selectedZone,
            selectedCircle,
            selectedWard,
            selectedTransferStation
          ),
          TeritaryVehicleDashboardReport(
            startDate,
            endDate,
            selectedTransferStation
          ),
        ]);

        // Update state variables with response data
        setAllVehicleDashboardReport(vehicleResponse.data);
        setPieChartData(vehicleResponse.data);
        setTransactionCountData(transactionResponse.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsOptionsLoading(false)
      }
    };

    // Fetch data only if start date and end date are selected

    useEffect(()=>{
      handleSearch()
    },[])
  
  useEffect(() => {
    if (transferStationDashboardResults.length > 0) {
      const markers = transferStationDashboardResults.map((station) => ({
        tsName: station.transferStationName,
        lat: station.latitude,
        lng: station.longitude,
      }));
      setTransferStationMarkers1(markers);
    }
  }, [transferStationDashboardResults]);

  useEffect(() => {
    if (
      (selectedZone || selectedCircle || selectedWard) &&
      transferStationDashboardResults.length > 0
    ) {
      // Filter transfer stations based on the selected zone, circle, and ward
      let filteredStations = transferStationDashboardResults;
      if (selectedZone) {
        filteredStations = filteredStations.filter(
          (station) => station.zoneId === selectedZone
        );
      }
      if (selectedCircle) {
        filteredStations = filteredStations.filter(
          (station) => station.circle_id === selectedCircle
        );
      }
      if (selectedWard) {
        filteredStations = filteredStations.filter(
          (station) => station.ward_id === selectedWard
        );
      }

      // Check if filtered stations have valid latitudes and longitudes
      const stationsWithCoordinates = filteredStations.filter(
        (station) => station.lat && station.long
      );

      if (stationsWithCoordinates.length > 0) {
        // Extract unique latitudes and longitudes for valid stations
        const uniqueCoordinates = {};
        stationsWithCoordinates.forEach((station) => {
          uniqueCoordinates[`${station.lat}-${station.long}`] = {
            lat: station.lat,
            lng: station.long,
          };
        });

        // Create an array of unique coordinates for markers
        const markers = Object.values(uniqueCoordinates);

        setTransferStationMarkers(markers);
      } else {
        // No valid coordinates found, clear markers
        setTransferStationMarkers([]);
      }
    } else {
      // If no zone, circle, or ward is selected, show all markers
      if (transferStationDashboardResults.length > 0) {
        // Filter out stations without valid latitudes and longitudes
        const validStations = transferStationDashboardResults.filter(
          (station) => station.lat && station.long
        );

        // Extract unique latitudes and longitudes for valid stations
        const uniqueCoordinates = {};
        validStations.forEach((station) => {
          uniqueCoordinates[`${station.lat}-${station.long}`] = {
            lat: station.lat,
            lng: station.long,
          };
        });

        // Create an array of unique coordinates for markers
        const markers = Object.values(uniqueCoordinates);

        setTransferStationMarkers(markers);
      }
    }
  }, [
    selectedZone,
    selectedCircle,
    selectedWard,
    transferStationDashboardResults,
  ]);

  useEffect(() => {
    const fetchZones = async () => {
      try {
        const zonesData = await GetZone();
        const delhiZones = (Array.isArray(zonesData) ? zonesData : []).filter(
          (zone) =>
            zone.isActive &&
            String(zone.zoneName || "").toLowerCase().includes("delhi")
        );
        setAllZones(delhiZones);
        if (delhiZones.length > 0) {
          setSelectedZone((prev) => prev || String(delhiZones[0].zoneId));
        }
      } catch (error) {
        console.error("Error fetching zones data:", error);
      }
    };

    fetchZones();
  }, []);

  useEffect(() => {
    const fetchCirclesByZone = async () => {
      try {
        if (selectedZone) {
          // Fetch circles based on the selected zone ID
          const circlesData = await GetCirclebyID(selectedZone);
          setAllCircles(circlesData);
        } else {
          setAllCircles([]);
        }
      } catch (error) {
        console.error("Error fetching circles data:", error);
      }
    };

    fetchCirclesByZone();
  }, [selectedZone]);

  useEffect(() => {
    const fetchWardsByCircle = async () => {
      try {
        if (selectedCircle) {
          // Fetch wards based on the selected circle ID
          const wardsData = await GetWardsbyCircleId(selectedCircle);
          setAllWards(wardsData); // Assuming wards data is in the format you expect
        } else {
          setAllWards([]); // Reset wards if no circle is selected
        }
      } catch (error) {
        console.error("Error fetching wards data:", error);
      }
    };

    fetchWardsByCircle();
  }, [selectedCircle]);
  // Modify the generatePieChart function to handle the chart generation
  const generatePieChart = () => {

    if (!pieChartRef.current || !pieChartData) {
      return; // Exit early if the canvas reference or data is missing
    }

    const ctx = pieChartRef.current.getContext("2d");
    if (pieChartInstance.current !== null) {
      pieChartInstance.current.destroy();
    }
    pieChartInstance.current = new Chart(ctx, {
      type: "pie",
      data: {
        labels: Object.keys(pieChartData),
        datasets: [{
          data: Object.values(pieChartData),
          backgroundColor: [
            '#FF6384',
            '#36A2EB',
            '#FFCE56',
            '#4BC0C0',
            '#9966FF',
            '#FF9F40',
          ],
          hoverOffset: 4,
        }],
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: 'Transaction Counts by Vehicle Type',
          },
        },
      },
    });
  };




  useEffect(() => {
    // Generate pie chart when pieChartData state changes
    generatePieChart();
  }, [pieChartData]);

  const customIcon = new L.Icon({
    iconUrl: "../../../assets/images/locationred.svg",
    iconSize: [50, 50],
  });


  const getTransferStationName = () => {
    if (!selectedTransferStation || !transferStationDashboardResults) return "";

    const matchedStation = transferStationDashboardResults.find(
      (station) => station.transferStationId == selectedTransferStation
    );
    console.log(transferStationDashboardResults)

    return matchedStation ? matchedStation.transferStationName : "Not Found";
  };

  // Usage
  const transferStationName = getTransferStationName();


  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content ">
          <h4 className="text-start mb-3">Secondary Deoployment Dashboard</h4>
          <div className="card">
            <div className="card-body">
              <div className="row" style={{ textAlign: "justify" }}>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="toDate">Select Transfer Station Name</label>
                    <select
                      type="text"
                      name="point_name"
                      className="form-select"
                      style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                      value={selectedTransferStation}
                      onChange={(e) => {
                        setSelectedTransferStation(e.target.value);
                        // Find the selected transfer station by name
                        const selectedStation =
                          transferStationDashboardResults.find(
                            (station) => station.transferStationId == e.target.value
                          );
                        if (selectedStation) {
                          // Update map center and markers to display only the selected transfer station
                          setMapCenter({
                            tsname: selectedStation.transferStationName,
                            lat: selectedStation.latitude,
                            lng: selectedStation.longitude,
                          });
                          setTransferStationMarkers([
                            {
                              lat: selectedStation.latitude,
                              lng: selectedStation.longitude,
                            },
                          ]);
                        } else {
                          // If no transfer station is selected, reset map center and display all markers
                          setMapCenter({ lat: 17.385044, lng: 78.486671 }); // Default center coordinates
                          setTransferStationMarkers(
                            transferStationDashboardResults.map((station) => ({
                              lat: station.latitude,
                              lng: station.longitude,
                            }))
                          );
                        }
                        // Clear selected zone and circle to avoid conflicts
                        setSelectedZone("");
                        setSelectedCircle("");
                      }}
                    >
                      <option value="">All</option>
                      {transferStationDashboardResults.filter((station)=>station.isActive).map((station) => (
                        <option
                          key={station.transferStationId}
                          value={station.transferStationId}
                        >
                          {station.transferStationName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-4 ">
                  <div className="form-group">
                    <label htmlFor="fromDate">From Date & Time</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      id="fromDate"
                      name="fromDate"
                      style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-4 ">
                  <div className="form-group">
                    <label htmlFor="toDate">To Date & Time</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      id="toDate"
                      name="toDate"
                      style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                      value={endDate}
                      onChange={(e) => {
                        // Check if end date is before start date
                        if (new Date(e.target.value) < new Date(startDate)) {
                          toast.warning("End date cannot be before start date");
                          return; // Don't update end date if it's invalid
                        }
                        setEndDate(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="fromDate">Select Zone</label>
                    <select
                      type="text"
                      name="zoneId"
                      className="form-select"
                      style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                      value={selectedZone || ""}
                      onChange={(e) => {
                        setSelectedCircle("");
                        setSelectedWard("");
                        setSelectedZone(e.target.value);
                      }}
                    >
                      {allZones.map((zone) => (
                        <option key={zone.zoneId} value={zone.zoneId}>
                          {zone.zoneName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="fromDate">Select Ward</label>
                    <select
                      type="text"
                      name="circle_id"
                      className="form-select"
                      style={{ backgroundColor: "#FFF", borderRadius: "0px" }}
                      value={selectedCircle}
                      onChange={(e) => {
                        setSelectedCircle(e.target.value);
                        setSelectedWard(null); // Clear the selected ward
                      }}
                    >
                      <option value="">All</option>
                      {allCircles?.map((circle) => (
                        <option
                          key={circle.circleId}
                          value={circle.circleId}
                          selected={circle.circleId === selectedCircle}
                        >
                          {circle.circleName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>


                <div className="col-md-2">
                  <div className="form-group"></div>
                  <button
                    type="button"
                    className={`btn mt-2 ${isProd ? "search-ghmc" : "search-swm"}`}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          {isOptionsLoading && <DashboardLoader />}
          <div className="row">
            <div className="col-md-12" >
              <div className="d-flex flex-wrap">
                {Object.entries(allVehicleDashboardReport).map(([vehicleType, count]) => (
                  <div className="col-md-3 mb-3 px-0">
                    <div
                      className="card shadow me-3"
                      style={{
                        textAlign: "justify"
                      }}
                    >
                      <div
                        className="card-body card_text_no"

                      >
                        <span className="card-head">
                          {vehicleType === "rcv" ? "CONTAINER" : vehicleType}
                        </span>
                        <p className="card-text" style={{ fontSize: '16px', fontWeight: 'bold' }}>{count}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>


          {pieChartData.length > 0 ?
            <div className="col-md-8 mt-3 me-auto p-0">
              <div className="card" style={{ boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px 0px" }}>
                <div className="card-header" style={{ textAlign: "justify" }}>
                  Activity
                </div>
                {/* <canvas ref={chartRef} /> */}
                <canvas ref={pieChartRef} />
              </div>
            </div> : ''}


          <div className="col-md-12 p-0">
            <div className="card" style={{ boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px 0px" }}>
              <div className="card-header">Map</div>
              <div className="card-body">

                <MapContainer
                  style={{ height: "400px", width: "100%" }}
                  center={mapCenter}
                  zoom={10}
                  ref={resetRef}
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  {/* Display markers for selected transfer station or all transfer stations */}
                  {selectedTransferStation ? (
                    <Marker
                      position={{ lat: mapCenter.lat, lng: mapCenter.lng }}
                      icon={customIcon}
                    >
                      <Popup>
                        <div>
                          <p>TS Name: {transferStationName}</p>
                        </div>
                      </Popup>
                    </Marker>
                  ) : (
                    // Show markers for all transfer stations
                    transferStationMarkers1.map((marker, index) => (
                      <Marker
                        key={index}
                        position={{ lat: marker.lat, lng: marker.lng }}
                        icon={customIcon}
                        eventHandlers={{
                          click: () => {
                            setSelectedMarker(marker);
                          },
                        }}
                      >
                        {selectedMarker && selectedMarker.lat === marker.lat && selectedMarker.lng === marker.lng && (
                          <Popup>
                            <div>
                              <p>TS Name: {selectedMarker.tsName}</p>
                            </div>
                          </Popup>
                        )}
                      </Marker>
                    ))
                  )}

                  {/* Display info window for selected marker */}
                  {/* {selectedMarker && (
                      <Popup
                        position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
                        onCloseClick={() => {
                          setSelectedMarker(null);
                        }}
                      >
                        <div>
                          <p>TS Name: {selectedMarker.tsName}</p>
                        </div>
                      </Popup>
                    )} */}
                </MapContainer>



              </div>
            </div>
          </div>

          <div className="row">
            {transactionCountData?.map((transaction) => {
              // Find the transfer station corresponding to the transaction
              const transferStation = transferStationDashboardResults.find(
                (station) =>
                  station.transferStationId === transaction.transferStationId
              );

              // Extract the transfer station name
              const transferStationName = transferStation
                ? transferStation.transferStationName
                : "Unknown Station";

              // return (
              //   <div
              //     className="col-md-2 mb-3 px-0"
              //     key={transaction.transferStationId}
              //   >
              //     <div
              //       className="card"
              //       style={{
              //         borderRadius: "15px",
              //         marginRight: "5px",
              //         textAlign: "justify",
              //         padding: "8px",
              //         boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px 0px",
              //         height: "100%",
              //       }}
              //     >
              //       <div
              //         className="card-body p-2"
              //         style={{
              //           display: "flex",
              //           flexDirection: "column",
              //           justifyContent: "space-between",
              //         }}
              //       >
              //         <span className="card-title">{transaction.vehicleTypeName}</span>
              //         <p className="card-text" style={{fontSize:'16px',fontWeight:'bold'}}>
              //           {transaction.transactionCount}
              //         </p>
              //       </div>
              //     </div>
              //   </div>
              // );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeritaryDashboardReport;

const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const hour = String(now.getHours()).padStart(2, "0");
  const minute = String(now.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hour}:${minute}`;
};
